import * as angular from 'angular';
import {IController} from "angular";

export class ProgramTypeMultiSelectHtmlComponent implements IController {
  programIds: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  constructor(private $mdSelect, private splitService) {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = this.splitService.getSiteProgramTypes();
    }
  }

  onReset() {
    this.onChange({programIds: []});
    this.$mdSelect.hide();
  }

  onCancel() {
    this.$mdSelect.hide();
  }

  onSelect() {
    this.onChange({programIds: this.programIds});
    this.$mdSelect.hide();
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('programTypeMultiSelect', {
    bindings: {
      programIds: '<',
      noUnderline: '<?',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./program-type-multi-select.html').default,
    controller: ProgramTypeMultiSelectHtmlComponent
  });
